var _path, _circle, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSummaryCreditIcon = function SvgSummaryCreditIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M23.069 12.468a9.177 9.177 0 1 1-18.354 0 9.177 9.177 0 0 1 18.354 0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.892,
    cy: 12.468,
    r: 1.245,
    fill: "#3D7C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D7C54",
    strokeLinecap: "round",
    d: "m13.965 12.457 4.512 1.494"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M20.576 12.425a6.782 6.782 0 1 0-11.18 5.163m8.795 0a6.775 6.775 0 0 0 2.127-3.304"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBE00",
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "M2.66 1v2.993M1.03 2.487H4.29"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSummaryCreditIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Summary_Credit_Icon.f7722ddd378c2b32f24ded96109e243c.svg";